import { ACADEMIC_PROGRAMME_CATEGORY } from './constant';
import { EVALUATION_TEXT } from './lang';
import { INTERVIEW_MODE, INTERVIEW_PANEL_LANGUAGE } from '../../constant';
import { PublicationType } from '../../../../Assessment/DRCAssessment/components/constants';
import { PAGE_TEXT } from '../../../../Assessment/lang';
import type { SelectOption } from '../../../../../components';

const PUBLICATION_TYPE =
  PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_B.PUBLICATION_TYPE;
export const researchTypeOptions: SelectOption[] = [
  {
    label: PUBLICATION_TYPE.JCR_Q1,
    value: PublicationType.JCR_Q1,
  },
  {
    label: PUBLICATION_TYPE.JCR_Q2,
    value: PublicationType.JCR_Q2,
  },
  {
    // to keep the original DoRPgS assessment remain the same, do not use the original NA constant
    label: PUBLICATION_TYPE.NA_OPTION,
    value: PublicationType.NA,
  },
];

export const interviewModeOptions: SelectOption[] = [
  {
    value: INTERVIEW_MODE.TELEPHONE,
    label: 'Telephone',
  },
  {
    value: INTERVIEW_MODE.VIDEO,
    label: 'Video',
  },
  {
    value: INTERVIEW_MODE.IN_PERSON,
    label: 'In-person',
  },
];

export const interviewLanguageOptions: SelectOption[] = [
  {
    value: INTERVIEW_PANEL_LANGUAGE.ENGLISH,
    label: 'English',
  },
  {
    value: INTERVIEW_PANEL_LANGUAGE.CHINESE_MANDARIN,
    label: 'Chinese (Mandarin)',
  },
  {
    value: INTERVIEW_PANEL_LANGUAGE.CHINESE_CANTONESE,
    label: 'Chinese (Cantonese)',
  },
  {
    value: INTERVIEW_PANEL_LANGUAGE.OTHERS,
    label: 'Others',
  },
];

export const academicProgrammeOptions: SelectOption[] = [
  {
    value: ACADEMIC_PROGRAMME_CATEGORY.MEDICINE,
    label: EVALUATION_TEXT.ACADEMIC_CATEGORY_A,
  },
  {
    value: ACADEMIC_PROGRAMME_CATEGORY.ENGINEERING,
    label: EVALUATION_TEXT.ACADEMIC_CATEGORY_B,
  },
  {
    value: ACADEMIC_PROGRAMME_CATEGORY.OTHERS,
    label: EVALUATION_TEXT.ACADEMIC_CATEGORY_C,
  },
];
